import { resolveAssignmentInstanceLabel } from '../../../utils/assignmentLabels';
function hasMeaningfulRichText(html) {
  return String(html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim().length > 0;
}

function submittedFeedbackRows(value) {
  const rows = Array.isArray(value)
    ? value
    : value
      ? [value]
      : [];

  return rows.filter(
    row =>
      row?.submitted === true &&
      hasMeaningfulRichText(row.comment)
  );
}

function assignmentLabel(
  assignment,
  allAssignments
) {
  const typeName =
    assignment
      ?.assignment_types
      ?.name ||
    'Assignment';

  const sameTypeCount =
    (allAssignments || [])
      .filter(
        candidate =>
          String(
            candidate.assignment_type_id
          ) ===
          String(
            assignment
              ?.assignment_type_id
          )
      )
      .length;

  return resolveAssignmentInstanceLabel(
    assignment,
    {
      baseName: typeName,
      sameTypeCount
    }
  );
}

export default function ForwardedAssignmentFeedback({
  destinationAssignmentId,
  allAssignments = [],
  submissions = []
}) {
  if (!destinationAssignmentId) return null;

  const sourceAssignments = (allAssignments || []).filter(
    assignment =>
      String(
        assignment.feedback_available_in_assignment_id || ''
      ) === String(destinationAssignmentId)
  );

  const groups = sourceAssignments
    .map(sourceAssignment => {
      const entries = (submissions || [])
        .filter(
          submission =>
            String(submission.course_assignment_id) ===
              String(sourceAssignment.id) &&
            submission.submitted === true
        )
        .flatMap(submission =>
          submittedFeedbackRows(
            submission.assignment_feedback
          ).map(feedback => ({
            submission,
            feedback
          }))
        )
        .sort((a, b) =>
          String(a.feedback?.submitted_at || '')
            .localeCompare(
              String(b.feedback?.submitted_at || '')
            )
        );

      return entries.length > 0
        ? {
            sourceAssignment,
            entries
          }
        : null;
    })
    .filter(Boolean);

  if (groups.length === 0) return null;

  return (
    <section style={styles.wrap}>
      {groups.map(group => {
        const sourceLabel = assignmentLabel(
          group.sourceAssignment,
          allAssignments
        );

        return (
          <div
            key={group.sourceAssignment.id}
            style={styles.group}
          >
            <div style={styles.heading}>
              Feedback from {sourceLabel}
            </div>

            {group.entries.map((entry, index) => {
              const fileLabel =
                entry.submission?.drive_file_name ||
                entry.submission?.file_name ||
                null;

              const itemLabel =
                group.entries.length > 1
                  ? fileLabel || `Item ${index + 1}`
                  : fileLabel;

              return (
                <div
                  key={
                    entry.feedback?.id ||
                    `${entry.submission?.id || 'submission'}-${index}`
                  }
                  style={styles.feedbackCard}
                >
                  {itemLabel && (
                    <div style={styles.itemLabel}>
                      {itemLabel}
                    </div>
                  )}

                  <div style={styles.feedbackLabel}>
                    Instructor feedback
                  </div>

                  <div
                    style={styles.feedbackText}
                    dangerouslySetInnerHTML={{
                      __html: entry.feedback.comment || ''
                    }}
                  />
                </div>
              );
            })}
          </div>
        );
      })}
    </section>
  );
}

const styles = {
  wrap: {
    margin: '14px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  group: {
    border: '1px solid #cfd8e3',
    borderRadius: '10px',
    background: '#f8fafc',
    padding: '14px'
  },
  heading: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#1f2933',
    marginBottom: '10px'
  },
  feedbackCard: {
    background: 'white',
    border: '1px solid #e3e8ee',
    borderRadius: '8px',
    padding: '12px',
    marginTop: '8px'
  },
  itemLabel: {
    fontSize: '12px',
    fontWeight: '700',
    color: '#486581',
    marginBottom: '7px'
  },
  feedbackLabel: {
    fontSize: '11px',
    fontWeight: '700',
    color: '#66788a',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: '6px'
  },
  feedbackText: {
    fontSize: '14px',
    lineHeight: '1.55',
    color: '#1f2933'
  }
};